import { StandardDialogFooter } from "../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import React, { useState } from "react";
import ActionDialogOrderList from "../order-list/action-dialog-order-list";
import { OrderModel } from "../../../../pages/shared/models/order/order-item.model";
import ordersService from "../../../../services/orders.service";
import EmptyScanPopup from "./shared/empty";
import {
  Message,
  MessageSections,
} from "../../../../pages/components/message/message";
import { ActionDialogContent } from "./shared/styled";
import { standardDialogColumns } from "./shared/columns";
import { TrackNumberInput } from "./track-number-input";
import { exportToExcel } from "../../../../pages/shared/helper-functions";
import { useAppSelector } from "../../../../redux/store";

const ScanForExport = ({
  onCancel,
  preSelectedOrders,
  orderStateId,
  ordersUpdated,
}: ScanForSearchDialogProps) => {
  const [orders, setOrders] = useState(preSelectedOrders || []);
  const { orderStates, currentRate } = useAppSelector(
    (state) => state.staticDataReducer,
  );

  function searchForOrder(trackingNumberToSearch: string) {
    if (
      !!trackingNumberToSearch.length &&
      !orders.some((order) =>
        order.products.some(
          (product) => product.trackingNumber === trackingNumberToSearch,
        ),
      )
    ) {
      const filter: { [key: string]: any } = {
        textQuery: trackingNumberToSearch,
      };

      if (orderStateId) {
        filter.state = orderStateId;
      }

      if (filter) {
        ordersService
          .getOrderByGivenFilterCriteria(filter)
          .then((order) => {
            if (order) {
              const newOrders = [...orders, order];
              updateOrders(newOrders);
            }
          })
          .catch((reason) => {
            console.log(reason);
          });
      }
    }
  }

  function updateOrders(orders: OrderModel[]) {
    setOrders(orders);
    ordersUpdated(orders);
  }

  function onExport() {
    let fileName = "";
    if (typeof orderStateId === "number") {
      fileName =
        orderStates.find((state) => state.orderStateId === orderStateId)
          ?.name || "";
    } else {
      fileName = orderStateId || "";
    }

    exportToExcel(fileName, orders, currentRate);
  }

  return (
    <>
      <ActionDialogContent>
        <TrackNumberInput onEnter={searchForOrder} />

        {orders.length ? (
          <ActionDialogOrderList
            orders={orders}
            columns={standardDialogColumns}
            updateOrders={updateOrders}
          />
        ) : (
          <EmptyScanPopup />
        )}
      </ActionDialogContent>

      <StandardDialogFooter
        saveLabel={
          orders.length ? (
            <Message messageKey={"export"} sectionId={MessageSections.ORDERS} />
          ) : undefined
        }
        onSave={() => onExport()}
        onCancel={() => onCancel()}
      />
    </>
  );
};

interface ScanForSearchDialogProps {
  onCancel: () => void;
  preSelectedOrders: OrderModel[] | undefined;
  orderStateId: string | number | undefined;
  ordersUpdated: (orders: OrderModel[]) => void;
}

export default ScanForExport;
